var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.979 295.59H264.023L224 208.451L183.979 295.59ZM384 32H64C28.654 32 0 60.654 0 96V416C0 451.346 28.654 480 64 480H384C419.348 480 448 451.346 448 416V96C448 60.654 419.348 32 384 32ZM330.057 381.77C326.791 383.275 323.369 383.998 320.01 383.998C310.932 383.998 302.262 378.818 298.199 369.996L286.172 343.813H161.828L149.803 369.996C144.225 382.084 130.037 387.357 117.945 381.77C105.914 376.213 100.664 361.865 106.211 349.777L202.205 140.809C210.049 123.73 237.953 123.73 245.797 140.809L341.789 349.777C347.336 361.865 342.086 376.213 330.057 381.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareA);
export default __webpack_public_path__ + "static/media/square-a.f6fba3a2235aef6f0d6fe6365f19dcfc.svg";
export { ForwardRef as ReactComponent };